import styled from "styled-components";

export const ChatInputStyles = styled.div`
  width: 100%;
  padding: 12px 14px;

  .presetRow {
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    margin-bottom: 0;
    transition: max-height 0.3s cubic-bezier(0.32, 0.72, 0.32, 1),
      opacity 0.2s ease,
      margin-bottom 0.3s cubic-bezier(0.32, 0.72, 0.32, 1);
  }
  .presetRow.isOpen {
    max-height: 240px;
    opacity: 1;
    margin-bottom: 10px;
  }
  .presetRowInner {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 4px 4px 10px;
    border-bottom: 1px dashed ${({ theme }) => theme.colors.warn[100]};
  }
  .presetTopRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
  .presetLabel {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.warn[700]};
  }
  .presetSave {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 10px;
    background: ${({ theme }) => theme.colors.warn[500]};
    color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-family: inherit;
    font-size: 12px;
    font-weight: 600;
  }
  .presetSave:hover {
    background: ${({ theme }) => theme.colors.warn[600]};
  }
  .presetSave svg {
    width: 12px;
    height: 12px;
  }
  .presetChips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .presetEmpty {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.warn[600]};
    font-style: italic;
    padding: 4px 0;
  }
  .presetChip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 6px 5px 12px;
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid ${({ theme }) => theme.colors.warn[100]};
    border-radius: 999px;
    font-size: 13px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.warn[700]};
    cursor: pointer;
    transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;
    max-width: 280px;
  }
  .presetChipText {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .presetChip:hover {
    background: ${({ theme }) => theme.colors.warn[500]};
    color: #fff;
    border-color: ${({ theme }) => theme.colors.warn[500]};
  }
  .presetX {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.warn[50]};
    border: none;
    color: ${({ theme }) => theme.colors.warn[600]};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
  }
  .presetChip:hover .presetX {
    background: rgba(255, 255, 255, 0.18);
    color: rgba(255, 255, 255, 0.85);
  }
  .presetX svg {
    width: 8px;
    height: 8px;
  }

  .inputRow {
    display: flex;
    align-items: flex-end;
    gap: 8px;
  }

  .modeBtn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    border: 1px solid transparent;
    background: ${({ theme }) => theme.colors.accent[50]};
    color: ${({ theme }) => theme.colors.accent[500]};
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.15s ease;
    padding: 0;
  }
  .modeBtn:hover {
    background: ${({ theme }) => theme.colors.accent[100]};
  }
  .modeBtn.isActive {
    background: ${({ theme }) => theme.colors.warn[500]};
    color: #fff;
    border-color: ${({ theme }) => theme.colors.warn[500]};
    box-shadow: 0 0 0 3px rgba(232, 148, 38, 0.15);
  }
  .modeBtn svg {
    width: 16px;
    height: 16px;
  }

  .inputShell {
    flex: 1;
    position: relative;
    min-width: 0;
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid
      ${({ $isNotif, theme }) =>
        $isNotif ? theme.colors.warn[500] : theme.colors.semantic.outline.default};
    border-radius: 10px;
    display: flex;
    align-items: flex-end;
    transition: border-color 0.15s ease;
  }
  .inputShell:focus-within {
    border-color: ${({ $isNotif, theme }) =>
      $isNotif ? theme.colors.warn[600] : theme.colors.accent[500]};
  }

  .chatTextInput {
    flex: 1;
    min-width: 0;
    min-height: 36px;
    max-height: 120px;
    padding: 8px 14px;
    border: none;
    outline: none;
    background: transparent;
    font-family: inherit;
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    resize: none;
    overflow-y: auto;
    scrollbar-width: thin;
  }
  .chatTextInput::-webkit-scrollbar {
    width: 6px;
  }
  .chatTextInput::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.primary[150]};
    border-radius: 999px;
  }
  .chatTextInput::placeholder {
    color: ${({ theme }) => theme.colors.semantic.text.placeholder};
  }

  .emojiWrap {
    position: relative;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    margin-bottom: 4px;
  }
  .emojiBtn {
    width: 28px;
    height: 28px;
    margin-right: 4px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }
  .emojiBtn:hover {
    color: ${({ theme }) => theme.colors.accent[500]};
    background: ${({ theme }) => theme.colors.accent[50]};
  }
  .emojiBtn svg {
    width: 18px;
    height: 18px;
  }

  .sendBtn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    border: none;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: not-allowed;
    background: ${({ theme }) => theme.colors.accent[100]};
    color: ${({ theme }) => theme.colors.accent[300]};
    transition: all 0.15s ease;
    padding: 0;
  }
  .sendBtn.isReady {
    cursor: pointer;
    background: ${({ $isNotif, theme }) =>
      $isNotif ? theme.colors.warn[500] : theme.colors.accent[500]};
    color: #fff;
  }
  .sendBtn.isReady:hover {
    background: ${({ $isNotif, theme }) =>
      $isNotif ? theme.colors.warn[600] : theme.colors.accent[600]};
  }
  .sendBtn svg {
    width: 16px;
    height: 16px;
  }

  .modeHint {
    font-size: 11px;
    padding: 6px 4px 0;
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${({ $isNotif, theme }) =>
      $isNotif ? theme.colors.warn[600] : theme.colors.semantic.text.weak};
  }
  .modeHint svg {
    flex-shrink: 0;
    width: 12px;
    height: 12px;
  }
  .hintMuted kbd {
    display: inline-block;
    padding: 1px 5px;
    background: ${({ theme }) => theme.colors.accent[50]};
    color: ${({ theme }) => theme.colors.accent[500]};
    border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    border-radius: 4px;
    font-family: inherit;
    font-size: 10px;
    font-weight: 500;
  }

  @media only screen and (max-width: 380px) {
    .emoji-mart {
      width: 250px !important;
    }
  }
`;
